module.exports = __webpack_public_path__ + "static/media/farmboost.24ace00d.png";